// $(document).ready(function () {
//   /* NAV TAB */
//   $(document).on("click", ".nav-tabs li a", function (e) {
//     e.preventDefault();
//     var href = $(this).attr("href");
//     $(this).parent().siblings().removeClass("active");
//     $(this).parent().addClass("active");
//     $(".tab-pane" + href)
//       .siblings()
//       .removeClass("active");
//     $(".tab-pane" + href).addClass("active");
//     $(".tab-pane" + href)
//       .find(".slick-slider")
//       .slick("setPosition");
//   });

//   $(document).on("change", ".mobile-tab select", function () {
//     var val = $(this).val();
//     $(".tab-pane" + val)
//       .siblings()
//       .removeClass("active");
//     $(".tab-pane" + val).addClass("active");
//     $(".tab-pane" + val)
//       .find(".slick-slider")
//       .slick("setPosition");
//   });
// });

// $(document).ready(function () {
//   $(".search-box-guide").click(function () {
//     console.log("hello");
//     $(".search-box-panel").addClass("active");
//   });
//   $(".close").click(function () {
//     $(".search-box-panel").removeClass("active");
//   });
// });



// $(document).ready(function () {
//   $(".faq_list .nav-tabs li").click(function () {
//     console.log("hello");
//     $(".faq_list .nav-tabs li").removeClass("active-new");
//     $(this).addClass("active-new");
//   });

//   $("#ingredients .grid-container a").on("click", function (event) {
//     event.preventDefault(); // Prevent default anchor behavior
//     var href = $(this).attr("href"); // Get the href attribute value
//     var popupContent = $('[data-hash="' + href.substring(1) + '"]'); // Get corresponding popup content

//     // Check if popup content exists
//     if (popupContent.length > 0) {
//       $("#popupContainer").show(); // Display the popup container
//       popupContent.addClass("active"); // Add active class to corresponding popup content
//     }
//   });
//   $(".slider-grid-container .close").on("click", function () {
//     $("#popupContainer").hide(); // Hide the popup container
//     $(".slider-grid-container").removeClass("active"); // Remove active class from all popup contents
//   });

//   $(".faq_content ul.accordion li.js-accordion").click(function () {
//     console.log("hello");
//     $(".faq_content ul.accordion li.js-accordion").removeClass("open");
//     $(".faq_content ul.accordion li.js-accordion")
//       .childern(".js-accordion-content")
//       .css("display", "none");

//     $(this).addClass("open");
//     $(this).childern(".js-accordion-content").css("display", "block");
//   });
// });

// $(document).ready(function () {
//   $(".multiple-items").slick({
//     lazyLoad: 'ondemand',
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     // rtl: true,
//     // ltr: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 991,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });


// $(document).ready(function () {
//   $(".remove-radius .icon-strip__wrapper").slick({
//     dots: false,
//     arrows: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     // rtl: true,
//     // ltr: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 991,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });

// $(document).ready(function () {
//   $(".anouncment-slide").slick({
//     dots: false,
//     arrows: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     // rtl: true,
//     // ltr: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 991,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });

// $(document).ready(function () {
//   $(".retual-slides").slick({
//     dots: false,
//     arrows: false,
//     infinite: false,
//     lazyLoad: 'ondemand',
//     speed: 300,
//     slidesToShow: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     slidesToScroll: 4,
//     // rtl: true,
//     // ltr: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: false,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".customer-slider").slick({
//     dots: true,
//     infinite: true,
//     lazyLoad: 'ondemand',
//     speed: 300,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 991,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 575,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: true,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".featureproduct-slider").slick({
//     dots: true,
//     infinite: true,
//     lazyLoad: 'ondemand',
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 991,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 575,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: true,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".banner-slider-section").slick({
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     arrows: true,
//     autoplay: true,
//     autoplaySpeed: 5000,
//     slidesToShow: 1,
//     lazyLoad: 'ondemand',
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });

// $(document).ready(function () {
//   $(".colleciton-list-slide").slick({
//     dots: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     lazyLoad: 'ondemand',
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".routine-slide").slick({
//     dots: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     lazyLoad: 'ondemand',
//     slidesToScroll: 1,
//     arrow: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           arrow: false,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
      
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".ingridient-strip").slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           dots: true,
//           infinite: true,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });
// $(document).ready(function () {
//   $(".icon-stip-slider").slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     arrows: true,
//     lazyLoad: 'ondemand',
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           dots: true,
//           infinite: true,
//         },
//       },
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ],
//   });
// });

// // product dropdown js
// $(document).ready(function () {
//   $("#acc .accInner").eq(0).addClass("active");
//   $("#acc .accInner-heading .accInner-title").click(function () {
//     let x = $(this).siblings().hasClass("");
//     let y = $(this)
//       .parents(".panel-group")
//       .find(".panel-collapse")
//       .not(".show");

//     $(this).parent().siblings(".accInner-body").slideToggle();
//     $(this).parents(".accInner").siblings().find(".accInner-body").slideUp();
//     $(this).parents(".accInner").toggleClass("active");
//     $(this).parents(".accInner").siblings().removeClass("active");
//   });
// });

// jQuery(document).ready(function () {
//   /* Open lightbox on button click */
//   $(".lightbox-toggle").click(function () {
//     $("body").addClass("stopScroll");
//     $(".backdrop")
//       .animate({ opacity: ".50" }, 300, "linear")
//       .css("display", "block");
//     $(".box").fadeIn();
//   });

//   /* Click to close lightbox */
//   $(".close, .backdrop").click(function () {
//     $(".backdrop").animate({ opacity: "0" }, 300, "linear", function () {
//       $(".backdrop").css("display", "none");
//     });
//     $(".box").fadeOut();
//     $("body").removeClass("stopScroll");
//   });

//   /* Open lightbox on button click */
//   $(".supp-lightbox-toggle").click(function () {
//     $("body").addClass("stopScroll");
//     $(".backdrop")
//       .animate({ opacity: ".50" }, 300, "linear")
//       .css("display", "block");
//     $(".supp-facts").fadeIn();
//   });

//   /* Click to close lightbox */
//   $(".close, .backdrop").click(function () {
//     $(".backdrop").animate({ opacity: "0" }, 300, "linear", function () {
//       $(".backdrop").css("display", "none");
//     });
//     $(".supp-facts").fadeOut();
//     $("body").removeClass("stopScroll");
//   });
// });


// // $(document).ready(function() {

// //   console.log("track order")
// //   // On click event for the anchor with class frcp-order__tracking-link
// //   $('.frcp-order__tracking-link').on('click', function(event) {
// //     event.preventDefault(); // Prevent the default anchor link behavior
    
// //     // Add the class "frcp-order--expanded" to the closest parent with class "frcp-order"
// //     $(this).closest('.frcp-order').addClass('frcp-order--expanded');
    
// //     // Add the CSS property to the nearest element with class "frcp-order__details"
// //     $(this).closest('.frcp-order').find('.frcp-order__details').css('max-height', '680px');
// //   });
// // });


// $(document).ready(function() {
//   console.log("track order")
//   // On click event for the .frcp-order__tracking-link
//   $('.frcp-order__tracking-link').on('click', function(event) {
//     event.preventDefault(); // Prevent default link behavior
    
//     // Find the closest .frcp-order div
//     var orderDiv = $(this).closest('.frcp-order');
    
//     // Toggle the class frcp-order--expanded on the .frcp-order div
//     orderDiv.toggleClass('frcp-order--expanded');
    
//     // Toggle the max-height CSS property on the .frcp-order__details div
//     var detailsDiv = orderDiv.find('.frcp-order__details');
//     if(detailsDiv.css('max-height') === '680px') {
//       detailsDiv.css('max-height', ''); // Remove max-height
//     } else {
//       detailsDiv.css('max-height', '680px'); // Add max-height
//     }
//   });
// });

// $(document).ready(function() {
// $('.customer-says').slick({
//   // centerMode: true,
//   // centerPadding: '60px',
//   dots: false,
//     autoplay: true,
//   arrows: false,
//     autoplaySpeed: 5000,
//     infinite: true,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1
//       }
//     }
//   ]
// });

//   $('.testimonial-text-review').slick({
//   // centerMode: true,
//   // centerPadding: '60px',
//   dots: false,
//     autoplay: true,
//   arrows: true,
//     autoplaySpeed: 3000,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//          arrows: false,
//       }
//     }
//   ]
// });
// });
// document.addEventListener('DOMContentLoaded', function () {
//   // Select all headings in the article content (h2, h3, etc.)
//   var headings = document.querySelectorAll('.article-content h2, .article-content h3, .article-content h4');

//   // Create the Table of Contents list
//   var tocList = document.getElementById('table-of-contents');

//   headings.forEach(function (heading, index) {
//     // Create an ID based on the heading text (remove spaces and special characters)
//     var id = heading.textContent.trim().replace(/\s+/g, '-').toLowerCase().replace(/[^\w-]/g, '');

//     // Set the ID for the heading element
//     heading.id = id;

//     // Create a list item for this heading in the table of contents
//     var listItem = document.createElement('li');
//     var anchor = document.createElement('a');
//     anchor.href = '#' + id; // Link to the heading by its ID
//     anchor.textContent = heading.textContent;
    
//     listItem.appendChild(anchor);
//     tocList.appendChild(listItem);
//   });
// });



/**
 * main-optimized.js
 * Optimized: combined $(document).ready calls, fixed typos, deferred slick init
 */

$(document).ready(function () {

  /* ─────────────────────────────────────────
     1. NAV TABS
  ───────────────────────────────────────── */
  $(document).on("click", ".nav-tabs li a", function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $(this).parent().siblings().removeClass("active");
    $(this).parent().addClass("active");
    $(".tab-pane" + href).siblings().removeClass("active");
    $(".tab-pane" + href).addClass("active");
    $(".tab-pane" + href).find(".slick-slider").slick("setPosition");
  });

  $(document).on("change", ".mobile-tab select", function () {
    var val = $(this).val();
    $(".tab-pane" + val).siblings().removeClass("active");
    $(".tab-pane" + val).addClass("active");
    $(".tab-pane" + val).find(".slick-slider").slick("setPosition");
  });

  /* ─────────────────────────────────────────
     2. SEARCH BOX PANEL
  ───────────────────────────────────────── */
  $(".search-box-guide").on("click", function () {
    $(".search-box-panel").addClass("active");
  });

  // Note: .close is also used by lightbox – this handles search panel close
  $(document).on("click", ".search-box-panel .close", function () {
    $(".search-box-panel").removeClass("active");
  });

  /* ─────────────────────────────────────────
     3. FAQ TABS
  ───────────────────────────────────────── */
  $(".faq_list .nav-tabs li").on("click", function () {
    $(".faq_list .nav-tabs li").removeClass("active-new");
    $(this).addClass("active-new");
  });

  /* ─────────────────────────────────────────
     4. INGREDIENTS POPUP
  ───────────────────────────────────────── */
  $("#ingredients .grid-container a").on("click", function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    var popupContent = $('[data-hash="' + href.substring(1) + '"]');
    if (popupContent.length > 0) {
      $("#popupContainer").show();
      popupContent.addClass("active");
    }
  });

  $(".slider-grid-container .close").on("click", function () {
    $("#popupContainer").hide();
    $(".slider-grid-container").removeClass("active");
  });

  /* ─────────────────────────────────────────
     5. FAQ ACCORDION
     FIX: "childern" typo → "children"
  ───────────────────────────────────────── */
  $(".faq_content ul.accordion li.js-accordion").on("click", function () {
    $(".faq_content ul.accordion li.js-accordion").removeClass("open");
    $(".faq_content ul.accordion li.js-accordion")
      .children(".js-accordion-content")
      .css("display", "none");
    $(this).addClass("open");
    $(this).children(".js-accordion-content").css("display", "block");
  });

  /* ─────────────────────────────────────────
     6. PRODUCT DROPDOWN ACCORDION
  ───────────────────────────────────────── */
  $("#acc .accInner").eq(0).addClass("active");

  $("#acc .accInner-heading .accInner-title").on("click", function () {
    $(this).parent().siblings(".accInner-body").slideToggle();
    $(this).parents(".accInner").siblings().find(".accInner-body").slideUp();
    $(this).parents(".accInner").toggleClass("active");
    $(this).parents(".accInner").siblings().removeClass("active");
  });

  /* ─────────────────────────────────────────
     7. LIGHTBOX (Ingredients / Supplement Facts)
  ───────────────────────────────────────── */
  $(".lightbox-toggle").on("click", function () {
    $("body").addClass("stopScroll");
    $(".backdrop").animate({ opacity: ".50" }, 300, "linear").css("display", "block");
    $(".box").fadeIn();
  });

  $(".supp-lightbox-toggle").on("click", function () {
    $("body").addClass("stopScroll");
    $(".backdrop").animate({ opacity: ".50" }, 300, "linear").css("display", "block");
    $(".supp-facts").fadeIn();
  });

  // Single unified close handler for both lightboxes
  $(".close, .backdrop").on("click", function () {
    $(".backdrop").animate({ opacity: "0" }, 300, "linear", function () {
      $(".backdrop").css("display", "none");
    });
    $(".box, .supp-facts").fadeOut();
    $("body").removeClass("stopScroll");
  });

  /* ─────────────────────────────────────────
     8. ORDER TRACKING TOGGLE
  ───────────────────────────────────────── */
  $(".frcp-order__tracking-link").on("click", function (e) {
    e.preventDefault();
    var $order = $(this).closest(".frcp-order");
    $order.toggleClass("frcp-order--expanded");
    var $details = $order.find(".frcp-order__details");
    $details.css("max-height", $details.css("max-height") === "680px" ? "" : "680px");
  });

  /* ─────────────────────────────────────────
     9. SLICK SLIDERS
     All sliders initialised together to avoid
     multiple $(document).ready overhead.
     FIX: "arrow: true" typo → "arrows: true" (routine-slide)
  ───────────────────────────────────────── */

  // Multiple items (3 per row)
  $(".multiple-items").slick({
    lazyLoad: "ondemand",
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  // Icon strip (remove-radius)
  $(".remove-radius .icon-strip__wrapper").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1 } }
    ]
  });

  // Announcement bar
  $(".anouncment-slide").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 991,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  // Ritual slides
  $(".retual-slides").slick({
    dots: false,
    arrows: false,
    infinite: false,
    lazyLoad: "ondemand",
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 4,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: false } },
      { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  // Customer reviews slider
  $(".customer-slider").slick({
    dots: true,
    infinite: true,
    lazyLoad: "ondemand",
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 575,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true } }
    ]
  });

  // Featured product slider
  $(".featureproduct-slider").slick({
    dots: true,
    infinite: true,
    lazyLoad: "ondemand",
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 991,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 575,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true } }
    ]
  });

  // Hero / banner slider
  $(".banner-slider-section").slick({
    dots: true,
    infinite: true,
    speed: 1000,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 600,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  

  // Routine slide – FIX: "arrow" → "arrows"
  $(".routine-slide").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, arrows: false, dots: true } },
      { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  // Ingredient strip
  $(".ingridient-strip").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, infinite: true } }
    ]
  });

  // Icon strip slider
  $(".icon-stip-slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    arrows: true,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, infinite: true } }
    ]
  });

  // Customer says
  $(".customer-says").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  });

  // Testimonial text review
  $(".testimonial-text-review").slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, arrows: false } }
    ]
  });

  /* ─────────────────────────────────────────
     10. TABLE OF CONTENTS (Blog / Article)
  ───────────────────────────────────────── */
  var tocList = document.getElementById("table-of-contents");
  if (tocList) {
    var headings = document.querySelectorAll(
      ".article-content h2, .article-content h3, .article-content h4"
    );
    headings.forEach(function (heading) {
      var id = heading.textContent
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase()
        .replace(/[^\w-]/g, "");
      heading.id = id;
      var li = document.createElement("li");
      var a  = document.createElement("a");
      a.href = "#" + id;
      a.textContent = heading.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    });
  }

}); // end $(document).ready